import React, { useState, useEffect } from 'react';
import DataGrid from '../components/DataGrid';
import { reportsAPI, lookupAPI } from '../services/api';

function ClientStatusQuickEdit({ embedded = false, refreshKey = 0, query = {} }) {
  const [terminationReasons, setTerminationReasons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTerminationReasons();
  }, []);

  const loadTerminationReasons = async () => {
    try {
      const response = await lookupAPI.getTerminationReasons();
      const reasons = response?.data?.data || [];
      setTerminationReasons(reasons);
    } catch (error) {
      console.error('Error loading termination reasons:', error);
      setTerminationReasons([]);
    } finally {
      setLoading(false);
    }
  };

  // Build columns with termination reason options
  const columns = [
    { key: 'last_name', label: 'Last Name' },
    { key: 'first_name', label: 'First Name' },
    { key: 'open_date', label: 'Open Date' },
    { key: 'close_date', label: 'Close Date' },
    { 
      key: 'termination_reason_label', 
      label: 'Termination Reason', 
      editKey: 'termination_reason_id',
      options: terminationReasons.map(reason => ({
        value: reason.id,
        label: reason.description || reason.code
      }))
    },
  ];

  const handleSaveRow = async (id, data) => {
    // Only send the editable fields
    const updateData = {
      open_date: data.open_date || null,
      close_date: data.close_date || null,
      termination_reason_id: data.termination_reason_id ? parseInt(data.termination_reason_id) : null,
    };
    
    await reportsAPI.updateClientStatus(id, updateData);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <DataGrid
      title="Client Status – Quick Edit"
      columns={columns}
      fetchUrl="client-status"
      editable={true}
      editableColumns={['open_date', 'close_date', 'termination_reason_id']}
      onSaveRow={handleSaveRow}
      embedded={embedded}
      refreshKey={refreshKey}
      query={query}
    />
  );
}

export default ClientStatusQuickEdit;
